import React from 'react'
import { Link } from 'react-router-dom'
import { isEmpty, startCase } from 'lodash'
import pluralize from 'pluralize'

import { Card } from '@/components/cards/Card'
import { Drawer } from '@/components/drawer/Drawer'
import { CommentEditorContainer } from '@/views/Playlists/components/CommentEditorContainer'
import { Pill } from '@/components/pills/Pill'
import { MAX_INLINE_TASKS } from '@/utils/constants'

export const TaskNotes = ({ tasks = [], callId, recordType, messageId }) => {
  const inlineTasks = tasks.slice(0, MAX_INLINE_TASKS)
  const titleId = recordType === 'email' ? messageId : callId

  const renderInlineTaskNotes = (task) => {
    return (
      <div key={task.task_id} className="call-comment" data-testid={`inline-task-${task.task_id}`}>
        <div className="flex-align-center flex-space-between gap">
          <Pill
            small
            warning={task.task_type === 'compliance'}
            success={task.task_type === 'coaching'}
          >
            {startCase(task.task_type)}
          </Pill>
          <div>{pluralize('note', task.notes.length, true)}</div>
        </div>
      </div>
    )
  }

  if (isEmpty(tasks)) {
    return null
  }

  return (
    <>
      <div>{inlineTasks.map((task) => renderInlineTaskNotes(task))}</div>
      <Drawer
        title={`Task Notes: ${titleId}`}
        trigger={(handleOpen) => (
          <div className="mt">
            <Pill small clickable onClick={handleOpen}>
              View All Notes
            </Pill>
          </div>
        )}
      >
        <div className="padding-medium">
          {tasks.map((task) => (
            <Card
              compact
              key={task.task_id}
              title={task.task_name}
              subtitle={
                <>
                  Task ID:{' '}
                  <Link
                    to={`/coaching/inbox?id=${task.task_id}`}
                    className="table-link call-explorer-link"
                  >
                    {task.task_id}
                  </Link>
                </>
              }
              buttons={
                <Pill
                  warning={task.task_type === 'compliance'}
                  success={task.task_type === 'coaching'}
                  data-testid="task-note-pill"
                >
                  {startCase(task.task_type)}
                </Pill>
              }
            >
              <CommentEditorContainer
                taskId={task.task_id}
                context="task"
                taskType={task.task_type}
              />
            </Card>
          ))}
        </div>
      </Drawer>
    </>
  )
}
